import { render, staticRenderFns } from "./systemMessage.vue?vue&type=template&id=540671d8&scoped=true&"
import script from "./systemMessage.vue?vue&type=script&lang=js&"
export * from "./systemMessage.vue?vue&type=script&lang=js&"
import style0 from "./systemMessage.vue?vue&type=style&index=0&id=540671d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540671d8",
  null
  
)

export default component.exports